// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"176":"projects","186":"company","245":"notfound","631":"contact","894":"services"}[chunkId] + "." + {"176":"4664d30f","186":"d88a2085","245":"754a4f97","631":"314d8bc1","894":"5ebe9289"}[chunkId] + ".css";
};